import { Component, Input, OnInit } from '@angular/core';
import { KakaoService } from 'src/app/services/kakao/kakao.service';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { LoginAlertDialogComponent } from '../../modals/login-alert-dialog/login-alert-dialog.component';

@Component({
  selector: 'result-save',
  templateUrl: './result-save.component.html',
  styleUrls: ['./result-save.component.scss'],
})
export class ResultSaveComponent implements OnInit {

  constructor(
    private logService: LogService,
    private modalService: ModalService,
    private kakaoService: KakaoService,
  ) { }

  @Input() description: string = "내 프로필에서 전체 결과와 친구들의 응답을 확인할 수 있어요"
  @Input() impressionLogging?: () => void
  @Input() buttonClickLogging?: () => void

  ngOnInit() {
    if(this.impressionLogging){
      this.impressionLogging();
    }else{
      this.logService.resultSaveImpressionLogging();
    }
  }

  async onClickSave(): Promise<void> {
    if(this.buttonClickLogging){
      this.buttonClickLogging();
    }else{
      this.logService.resultSaveButtonClickedLogging();
    }
    this.modalService.dismiss();
    const loginAlert = await this.modalService.openDialog(LoginAlertDialogComponent, {
      description: this.description
    });
    await loginAlert.present();
    const { data } = await loginAlert.onWillDismiss();
    if (data) {
      this.kakaoService.login(location.pathname);
    }
  }

}
